import { LogIn, FolderKanban, FileText, Zap, Shield } from 'lucide-react'
import { Button } from '@/components/ui/button'

export function LandingPage() {
  const handleLogin = () => {
    window.location.href = '/auth/login'
  }

  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* Header */}
      <header className="border-b border-border">
        <div className="container mx-auto px-4 h-16 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="h-8 w-8 rounded-lg bg-gradient-to-br from-monokai-pink to-monokai-purple flex items-center justify-center">
              <span className="text-white font-bold text-sm">D</span>
            </div>
            <span className="font-semibold text-lg">DSP</span>
          </div>
          <Button onClick={handleLogin} className="gap-2">
            <LogIn className="h-4 w-4" />
            Login
          </Button>
        </div>
      </header>

      {/* Hero */}
      <main className="flex-1 flex flex-col items-center justify-center px-4 py-20">
        <div className="max-w-3xl text-center space-y-8">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight leading-tight">
            Developer Service Platform
          </h1>
          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed">
            Plane project, Synology Drive, Mattermost를 project context 기준으로 연결하는
            search and context bridge입니다.
          </p>
          <div className="pt-4">
            <Button size="xl" onClick={handleLogin}>
              <LogIn className="h-5 w-5" />
              Authentik으로 로그인
            </Button>
          </div>
        </div>

        {/* Features */}
        <div className="mt-20 grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl w-full">
          <FeatureCard
            icon={FolderKanban}
            title="Plane project"
            description="Plane project를 canonical registry로 사용하고 issue와 page를 project context에 맞게 연결합니다."
          />
          <FeatureCard
            icon={FileText}
            title="Plane + Drive 검색"
            description="Plane issue/page와 Drive 파일을 source-aware search로 조회합니다."
          />
          <FeatureCard
            icon={Zap}
            title="Mattermost 연동"
            description="Mattermost channel 문맥을 slash search와 attachment flow에 연결합니다."
          />
          <FeatureCard
            icon={Shield}
            title="SSO 인증"
            description="Authentik OIDC 기반 Single Sign-On. 안전한 인증 관리."
          />
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-border py-6">
        <div className="container mx-auto px-4 text-center text-sm text-muted-foreground">
          IIP Lab Developer Service Platform
        </div>
      </footer>
    </div>
  )
}

interface FeatureCardProps {
  icon: React.ElementType
  title: string
  description: string
}

function FeatureCard({ icon: Icon, title, description }: FeatureCardProps) {
  return (
    <div className="p-6 sm:p-8 rounded-xl border border-border bg-card hover:border-accent/50 hover:shadow-lg transition-all duration-200">
      <div className="h-12 w-12 rounded-xl bg-accent/10 flex items-center justify-center mb-5">
        <Icon className="h-6 w-6 text-accent" />
      </div>
      <h3 className="text-lg font-semibold mb-3">{title}</h3>
      <p className="text-muted-foreground leading-relaxed">{description}</p>
    </div>
  )
}
